export const ORDER_UY = [
	"location-filter",
	"operation-type-filter",
	"temporal-filter",
	"guests-filter",
	"property-type-filter",
	"price-filter",
	"bedroom-filter",
	"rooms-filter",
	"bathrooms-filter",
	"amenities-filter",
	"property-state-filter",
	"publicationDate-filter",
	"floors-filter",
	"keyword-filter",
	"m2Type-filter",
	"advanced-filters",
	"seen-filter",
	"garage-filter",
	"sea-distance-filter",
	"disposition-filter",
	"socialhousing-filter",
	"privateowner-filter",
	"condominium-filter",
	"virtual-tour-filter",
];

export const ORDER_ce3 = [
	"seen-filter",
	"temporal-filter",
	"property-type-filter",
	"location-filter",
	"price-filter",
	"guests-filter",
	"sea-distance-filter",
	"bedroom-filter",
	"rooms-filter",
	"bathrooms-filter",
	"garage-filter",
	"property-state-filter",
	"amenities-filter",	
	"m2Type-filter",
	"publicationDate-filter",
	"privateowner-filter",
	"keyword-filter"
];

export const ORDER_BR = [
	"seen-filter",
	"location-filter",
	"socialhousing-filter",
	"virtual-tour-filter",
	"bedroom-filter",
	"rooms-filter",
	"bathrooms-filter",
	"price-filter",
	"property-state-filter",
	"property-type-filter",
	"percentage-finished-filter",
	"percentage-sold-filter",
	"price-m2-filter",
	"m2Type-filter",
	"architect-filter",
	"builder-filter",	
	"publicationDate-filter",
	"keyword-filter"
];
